import { createSafeJsonLd, SAFEMONK_ORGANIZATION, PUBLISH_DATE } from '@/lib/structured-data-utils';

export function WebApplicationStructuredData() {
  const webApplicationData = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "SafeMonk",
    "description": "Secure secret sharing with zero-knowledge encryption and burn-after-read functionality. Share passwords, API keys, and sensitive files with military-grade AES-GCM encryption.",
    "url": "https://www.safemonk.com",
    "applicationCategory": "SecurityApplication",
    "operatingSystem": "Any (Web Browser)",
    "browserRequirements": "Requires JavaScript and Web Crypto API support",
    "softwareVersion": "1.0",
    "datePublished": PUBLISH_DATE,
    "dateModified": new Date().toISOString().split('T')[0],
    "author": SAFEMONK_ORGANIZATION,
    "publisher": SAFEMONK_ORGANIZATION,
    "provider": SAFEMONK_ORGANIZATION,
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD",
      "availability": "https://schema.org/InStock"
    },
    "featureList": [
      "AES-GCM 256-bit encryption",
      "Zero-knowledge architecture",
      "Burn-after-read functionality", 
      "Client-side encryption",
      "File sharing up to 500MB",
      "Passphrase protection",
      "Anti-link-preview protection",
      "No registration required",
      "Automatic expiration",
      "Cross-browser compatibility"
    ],
    "screenshot": "https://www.safemonk.com/og-image.png",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5.0",
      "ratingCount": "1",
      "bestRating": "5",
      "worstRating": "1"
    },
    "installUrl": "https://www.safemonk.com",
    "requirements": "Modern web browser with Web Crypto API support (Chrome, Firefox, Safari, Edge)",
    "permissions": "Web Crypto API access for encryption operations",
    "downloadUrl": "https://www.safemonk.com",
    "applicationSubCategory": "Encryption, Privacy, Security",
    "about": {
      "@type": "Thing",
      "name": "Zero-knowledge secret sharing",
      "description": "Secure method of sharing sensitive information where the service provider cannot access the unencrypted data"
    },
    "audience": {
      "@type": "Audience",
      "audienceType": "Security-conscious users, developers, IT professionals"
    },
    "usageInfo": {
      "@type": "CreativeWork",
      "name": "How to use SafeMonk securely",
      "url": "https://www.safemonk.com/best-practices"
    }
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: createSafeJsonLd(webApplicationData)
      }}
    />
  );
}